<template>
  <div class="account-dashbord info">
    <template>
      <ul class="account-dashbord-tabs">
        <li
          class="account-dashbord-tab"
          :class="{'focus': curb===index}"
          @click="curb=index" v-for="(tab, index) in tabs"
          :key="index"
        >
          <div class="tab-word">{{tab}}</div>
        </li>
      </ul>

      <div class="info-bord" v-show="curb===0">
        <tgo-user-info></tgo-user-info>
      </div>

      <div class="info-bord" v-show="curb===1">
        <tgo-user-detail></tgo-user-detail>
      </div>
    </template>
  </div>
</template>
<script>
import tgoUserInfo from './user-base'
import tgoUserDetail from './user-edu'

export default {
  props: ['listId'],
  data () {
    return {
      curb: 0,
      tabs: ['基本信息', '就业及教育信息']
    }
  },
  created () {},
  components: {
    tgoUserInfo,
    tgoUserDetail
  },
  methods: {}
}
</script>
<style scoped lang='sass'>
@import '../assets/css/dashbord.sass'
@import '../../../style/bulma/app.sass'

.info
  .account-dashbord-tabs
    border-bottom: 1px solid #d9d9d9
    font-size: 17px
    font-weight: 400
    display: flex
    .account-dashbord-tab
      padding: 22px 20px 0
      .tab-word
        padding-bottom: 15px
        cursor: pointer
      &.focus
        .tab-word
          font-weight: 500
          color: $primary3
          border-bottom: 3px solid $primary3
  .info-bord
    padding: 20px 0

</style>
